import React from 'react'
import {
  FeaturedReviewsComponent,
  ConsumerReviewSearchQuery,
  FeaturedReviewFragment
} from '#src/generated/graphql'
import { Experiment, Variation } from '@deal/experiment-js'
import V1 from './v1'
import V2 from './v2'
import V3 from './v3'

interface FeaturedReviewsProps {
  forceFullGrid?: boolean
  header?: string
  subHeader?: string
  disableLinking?: boolean
  showMoreReviewsButton?: boolean
  className?: string
  featuredOnly?: boolean
  spotlightOnly?: boolean
  departmentIds?: string[]
  version?: 'v1' | 'v2' | 'v3'
  expertIds?: string[]
  slidesToShow?: number
  arrows?: boolean
  gutterSize?: number
  actions?: React.ReactNode
}

export interface FeaturedReviewsComponentProps extends FeaturedReviewsProps {
  featuredReviews: FeaturedReviewFragment[]
}

const Reviews: React.SFC<FeaturedReviewsProps> = ({
  featuredOnly,
  spotlightOnly,
  departmentIds,
  expertIds,
  version,
  ...props
}) => {
  let featuredReviewsQuery: ConsumerReviewSearchQuery = {
    departmentIds: departmentIds && departmentIds.length > 0 ? departmentIds : [],
    expertIds: expertIds && expertIds.length > 0 ? expertIds : [],
    facetedSearch: true,
    facets: []
  }

  if (featuredOnly && featuredReviewsQuery.facets) {
    const facet = {
      name: 'featured',
      bucketValues: ['YES']
    }

    featuredReviewsQuery.facets.push(facet)
  }

  if (spotlightOnly && featuredReviewsQuery.facets) {
    const facet = {
      name: 'spotlight',
      bucketValues: ['YES']
    }

    featuredReviewsQuery.facets.push(facet)
  }

  return (
    <FeaturedReviewsComponent
      variables={{
        query: featuredReviewsQuery
      }}
    >
      {({ data }) => {
        if (
          data &&
          data.consumerExpertReviewConnection &&
          data.consumerExpertReviewConnection.edges.length > 0
        ) {
          if (version === 'v1') {
            return (
              <V1
                {...props}
                featuredReviews={data.consumerExpertReviewConnection.edges.map(i => i.node)}
              />
            )
          }

          if (version === 'v2') {
            return (
              <V2
                {...props}
                featuredReviews={data.consumerExpertReviewConnection.edges.map(i => i.node)}
              />
            )
          }

          // V3 is only used on the product pages and is purposely discluded from the experiment
          if (version === 'v3') {
            return (
              <V3
                {...props}
                featuredReviews={data.consumerExpertReviewConnection.edges.map(i => i.node)}
              />
            )
          }

          return (
            <Experiment id="featured-reviews" default="v1">
              <Variation id="v1">
                <V1
                  {...props}
                  featuredReviews={data.consumerExpertReviewConnection.edges.map(i => i.node)}
                />
              </Variation>
              <Variation id="v2">
                <V2
                  {...props}
                  featuredReviews={data.consumerExpertReviewConnection.edges.map(i => i.node)}
                />
              </Variation>
            </Experiment>
          )
        }
        return null
      }}
    </FeaturedReviewsComponent>
  )
}

export default Reviews
